import React from 'react';
import { Loading, Modal, SystemText } from 'e4shared';
import { badgeData, getBadge } from 'data/badges';

import { hasModule } from 'helpers/profile';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';
import { e4Format } from 'helpers/dates';

const badges = props => {
    const { show, close, profileId, inModal } = props;

    const st = (path, ...rest) => SystemText(`Home/Widgets/Badges/${path}`, ...rest);

    const [loading, setLoading] = React.useState(true);
    const [profile, setProfile] = React.useState(null);

    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        if (profileId) {
            setLoading(true);
            apiGet(`profile/${profileId}?extra=badges`, user.guid, response => {
                setProfile(response);
                setLoading(false);
            });
        }
    }, [profileId]);

    if (!profileId) return null;

    const isMe = user.id === profile?.id;
    const title = isMe ? st('Title/You') : st('Title/Them', profile?.full_Name);

    const badges = profile?.badges || [];
    let lastGroup = '';

    const content = loading ? (
        <Loading />
    ) : (
        <div className="badge-list">
            <div style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {badges
                    .filter(b => b.badge_Id)
                    .map(badge => {
                        lastGroup = 'company';
                        if (badge.module && !hasModule(user, badge.module)) return null;
                        return (
                            <div key={`badge-${badge.badge_Id}`} className="mt10 flex flex-center">
                                <i
                                    style={{ width: '20px' }}
                                    className={
                                        badge.awarded ? `fa fa-check text-success mr5` : `fa fa-times text-danger mr5`
                                    }
                                    title={
                                        badge.awarded
                                            ? `${st('Awarded', e4Format(badge.awarded, null, true))}`
                                            : st('NotAwarded')
                                    }
                                />
                                <div>
                                    <label className="label label-default flex-grow">
                                        <i className={`mr5 badge-dot gold no-wrap`} />
                                        {badge.name}
                                    </label>
                                </div>
                                <span className="no-wrap">{badge.description}</span>
                            </div>
                        );
                    })}
            </div>
            <div>
                {badgeData().map(badge => {
                    if (!hasModule(user, badge.module)) return false;
                    const profileBadge = profile.badges.filter(d => d.type === badge.type);
                    badge.awarded = profileBadge.length > 0 ? profileBadge[0].awarded : null;
                    const marginClass = lastGroup === badge.group ? 'mt10' : 'mt20';
                    lastGroup = badge.group;
                    const clean = getBadge(badge.type);

                    return (
                        <div key={`badge-${badge.type}`} className={marginClass}>
                            <i
                                style={{ width: '20px' }}
                                className={badge.awarded ? `fa fa-check text-success mr5` : `fa fa-times text-danger mr5`}
                                title={
                                    badge.awarded
                                        ? `${st('Awarded', e4Format(badge.awarded, null, true))}`
                                        : st('NotAwarded')
                                }
                            />
                            <label className="label label-default">
                                <i className={`mr5 badge-dot ${badge.colour}`} />
                                {badge.name}
                            </label>
                            <span>{clean.description}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );

    return inModal ? (
        content
    ) : (
        <Modal show={show} title={title} id="badges-modal" close={close} footer={null}>
            {content}
        </Modal>
    );
};

export default badges;
